import { css } from '@emotion/react';

import { theme } from '../../theme';

export const styles = {
  paymentWrapper: css`
    border-radius: ${theme.borders.radius.sm};
    margin-bottom: ${theme.spacing.sm};
    display: flex;
    flex-direction: column;
    background-color: ${theme.colors.background.container};
    padding: ${theme.spacing.md};
  `,

  paymentContainer: css`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    @media (max-width: ${theme.breakpoints.laptop}) {
      flex-direction: column;
    }
  `,

  amountsContainer: css`
    min-width: 50%;
    display: flex;
    flex-direction: column;
    > p {
      margin: 0px;
      > div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
    }
    @media (max-width: ${theme.breakpoints.laptop}) {
      min-width: 100%;
      margin-bottom: ${theme.spacing.md};
    }
  `,

  totalPriceContainer: css`
    min-width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    gap: ${theme.spacing.sm};
    > h2 {
      margin: 0;
      color: ${theme.colors.text};
    }
    @media (max-width: ${theme.breakpoints.laptop}) {
      min-width: 100%;
      margin-top: ${theme.spacing.md};
    }
  `,
  totalPrice: css`
    font-size: ${theme.fontSize.xxl};
    font-weight: ${theme.fontWeight.black};
    margin-bottom: 0;
  `,
};
